module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.type === 'icon' ? 'display:inline-block;float:left;' : '')
  }, [(_vm.type === 'icon') ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: _vm.content,
        popover: {
          defaultClass: 'd-tooltip',
          defaultbaseClass: 'd-tooltip'
        }
      }),
      expression: "{\n        content: content,\n        popover: {\n            defaultClass: 'd-tooltip',\n            defaultbaseClass: 'd-tooltip'\n        }\n    }"
    }],
    staticClass: "fas fa-question-circle"
  }) : _c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb9345f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ContentfulGuide.vue
// module id = 893
// module chunks = 0